// extracted by mini-css-extract-plugin
export default {"link":"P0vF1Y","image":"TMWp1u","ScotchTapePhoto":"hKU0bV","scotchTapePhoto":"hKU0bV","wrp":"caraYp","xxx":"Omzn9k","left":"XzVLlD","right":"nSYwiV"};